import Vue from 'vue'
// 改变title文字描述
Vue.directive('title', {
inserted: function (el, binding) {
		console.log(el)
    	document.title = el.dataset.title
	}
})
